import { Outlet } from 'react-router-dom';

/**
 * Layout wrapper for authentication pages (login, register, etc.)
 * Simplified to allow full-page control within child components for 100% parity.
 */
export function AuthLayout() {
    return (
        <div className="min-h-screen bg-white">
            <Outlet />
        </div>
    );
}

export default AuthLayout;
